import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 路由变化时滚动到顶部（仅在路由跳转时）
    window.scrollTo(0, 0);
  }, [pathname]);

  // useEffect(() => {
  //   // 页面刷新时滚动到顶部
  //   const handleBeforeUnload = () => {
  //     window.scrollTo(0, 0);
  //   };

  //   const handleLoad = () => {
  //     window.scrollTo(0, 0);
  //   };

  //   // 监听页面刷新
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   window.addEventListener("load", handleLoad);

  //   // 立即滚动到顶部（处理页面刷新情况）
  //   window.scrollTo(0, 0);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     window.removeEventListener("load", handleLoad);
  //   };
  // }, []);

  return null;
};

export default ScrollToTop;
